import { useMemo } from 'react';
import { DuckQueryReturnOneType } from '../../duckDB/hooks/useDuckQueryScanData';
import { ScanDataEnum } from '../scanDataDefinitions';
import { OperatorEnum, useScanDataQuery } from './useScanDataQuery';

export enum StdDevFilterEnum {
  class_name = ScanDataEnum.class_name,
  model_name = ScanDataEnum.model_name,
  model_version = ScanDataEnum.model_version,
}

export interface FilterScanDataOptions {
  measure_col: string | null;
  skip?: boolean;
}

export interface StdDevQueryResult {
  std_dev: number;
}

export interface MeanQueryResult {
  mean: number;
}

const availableMeasures: string[] = [
  ScanDataEnum.count_per_meter,
  ScanDataEnum.estimated_count,
  ScanDataEnum.detection_length,
  ScanDataEnum.detection_area,
];

export const useScanDataStdDev = ({
  measure_col,
  skip = false,
}: FilterScanDataOptions): DuckQueryReturnOneType<number | null> => {
  // fallback measures to count if measure not available for this metric
  const measure = availableMeasures.includes(measure_col || '')
    ? measure_col
    : availableMeasures[0];

  const [cols, filters] = useMemo(() => {
    const cols = [`stddev_samp(${measure}) as std_dev`];

    const filters = [];
    if (measure) {
      filters.push({
        col: measure,
        op: OperatorEnum.neq,
        value: null,
      });
    }

    return [cols, filters];
  }, [measure]);

  const {
    data: scanStdDevFilteredByFeature,
    isLoading,
    error,
    query,
  } = useScanDataQuery<StdDevQueryResult>({
    cols,
    filters,
    useUnitsTransformSubstringMatching: true,
    skip: skip || !measure_col,
  });

  const scanStdDev = scanStdDevFilteredByFeature
    ? scanStdDevFilteredByFeature[0]?.std_dev
    : null;

  return {
    data: scanStdDev,
    isLoading,
    error,
    query,
  };
};
